<template>
  <div class="footer">
    <div>
      <p class="p-big">
        <a :href="config.introLink" target="_blank">公司简介</a>
        <span> | </span>
        <a :href="config.userProtocolLink" target="_blank">用户协议</a>
        <span> | </span>
        <a :href="config.privacyLink" target="_blank">隐私政策</a>
      </p>
      <p>适度游戏益脑 沉迷游戏伤身 合理安排时间 享受健康生活</p>
      <p>抵制不良游戏 拒绝盗版游戏 注意自我保护 谨防受骗上当</p>
      <p>{{ config.symbol }}</p>
      <p>网络游戏出版物号 {{ config.publicationNo }}</p>
      <p>
        <img
          src="../../assets/images/common/police.png"
          alt="图片加载失败"
          style="
            display: inline;
            width: 15px;
            height: 15px;
            vertical-align: top;
            margin: 2px 1px -5px 0;
          "
        />{{ config.backup }} | ICP证{{ config.ICPNo }} |
        <a
          style="color: #fff"
          href="https://beian.miit.gov.cn/"
          target="_blank"
          >{{ config.MICPNo }}</a
        >
      </p>
      <p>Copyright©{{ year }} QCPLAY {{ config.opUnit }} 版权所有</p>
      <p>本游戏适用{{ config.ageLimit }}岁以上玩家</p>
    </div>
  </div>
</template>
<script>
import { GAME_COPYRIGHT } from "@/config/constant";

export default {
  name: "Footer",
  components: {},
  created() {
    this.year = new Date().getFullYear();
    if (!this.gameName) {
      throw new Error("请传入gameName");
    }
    this.config = GAME_COPYRIGHT[this.gameName];
  },
  data() {
    return {
      year: 0,
      config: {}
    };
  },
  props: {
    gameName: {
      type: String, // 传入参数：snail | tideng | timeTravel | servitor | hjwq | qscy
      required: true,
      default: ""
    }
  }
};
</script>
<style lang="less" scoped>
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/components/Footer/index.vue